import { PropType } from 'vue'
import { CitedContextDatapoint } from '@/libs/features/llm/types'

export type LinkDestination = {
  path?: string
  query?: Record<string, any>
} | null

export const LLM_SOURCE_PROPS = {
  source: {
    type: Object as PropType<CitedContextDatapoint>,
    required: true,
  },
  patientId: {
    type: String as PropType<string>,
    required: true,
  },
} as const
